module.exports = __webpack_public_path__ + "static/media/ic-close.2ebabc09.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/peterpan/ic-close.svg
// module id = 298
// module chunks = 0